"use client"
import styles from "../../../../styles/LandingPage/NavBar.module.scss"
import Image from "next/image"
import * as Scroll from "react-scroll"
import classNames from "classnames"
import { IconButton } from "@mui/material"
import Button from "../../Button/Button"
import Link from "next/link"
import { usePathname } from "next/navigation"
import { CSSProperties, useState } from "react"
import StyledText from "../../../typography/typography-component"
import SkinuvitaDrawer from "../../drawer/skinuvita_drawer"
import { Routes, useTypedRouter } from "../../../data/routes"
import { TrackedActions } from "../../../tracking/trackedActions"

const NavbarQuickfix = ({
  scrollLinksDisabled = false,
  style,
}: {
  scrollLinksDisabled?: boolean
  style?: CSSProperties
}) => {
  const router = useTypedRouter()
  const pathname = usePathname()
  const scroll = Scroll.animateScroll
  const [drawerOpen, setDrawerOpen] = useState(false)
  return (
    <>
      <div style={style} className={styles.headerLarge}>
        <nav className={styles.topBar}>
          <div
            className={styles.bigLogo}
            onClick={() => router.push(Routes.home)}
            style={{
              cursor: "pointer",
              marginLeft: "60px",
            }}
          >
            <Image
              src={"/Skinuvita_full_logo.svg"}
              width={62}
              height={52}
              alt={"skinuvita logo"}
              style={{
                maxWidth: "100%",
                height: "auto",
              }}
            />
          </div>
          <div className={styles.grow} />
          {
            <ul className={styles.tabs}>
              <li className={classNames(styles.buttons)}>
                <a
                  tabIndex={1}
                  className={classNames("stretched-link", styles.link)}
                  onClick={() => void TrackedActions.goToSelfCheck()}
                >
                  <StyledText color={"unset"} variant={"unset"}>
                    Selbst-Check
                  </StyledText>
                </a>
              </li>
              <li className={classNames(styles.buttons)}>
                <Link tabIndex={2} className={classNames("stretched-link", styles.link)} href={Routes.ratgeber}>
                  <StyledText color={"unset"} variant={"unset"}>
                    Ratgeber
                  </StyledText>
                </Link>
              </li>
              <li className={classNames(styles.buttons)}>
                <Link tabIndex={3} className={classNames("stretched-link", styles.link)} href={"/#contact"}>
                  <StyledText color={"unset"} variant={"unset"}>
                    Über uns
                  </StyledText>
                </Link>
              </li>

              <li className={classNames(styles.buttons)}>
                <Link tabIndex={4} className={classNames("stretched-link", styles.link)} href={"/#contact"}>
                  <StyledText color={"unset"} variant={"unset"}>
                    Kontakt
                  </StyledText>
                </Link>
              </li>
              <li style={{ paddingBottom: "10px" }} className={classNames(styles.buttons)}>
                <Link tabIndex={5} href={pathname == Routes.doctors ? Routes.home : Routes.doctors}>
                  <Button tabIndex={-1} variant={"primary"} type={"button"} className={styles.linkButton}>
                    <StyledText className={styles.buttonText} variant={"unset"}>
                      {pathname == Routes.doctors ? "Für Patient:innen" : "Für Ärzt:innen"}
                    </StyledText>
                  </Button>
                </Link>
              </li>
            </ul>
          }
        </nav>
      </div>
      <div className={styles.headerSmall}>
        <nav className={styles.topBar}>
          <div
            className={styles.smallLogo}
            onClick={() => router.push(Routes.home)}
            style={{
              cursor: "pointer",
              transform: "translate(10px, 5px)",
            }}
          >
            <Image
              src={"/Skinuvita_cube.svg"}
              width={24}
              height={24}
              alt={"skinuvita logo"}
              style={{
                maxWidth: "100%",
                height: "auto",
              }}
            />
          </div>
          <div className={styles.grow} />
          {!scrollLinksDisabled && (
            <IconButton
              className={styles.burgerButton}
              onClick={() => setDrawerOpen(true)}
              style={{ color: "rgba(65, 145, 158, 1)" }}
            >
              <Image
                src={"/svg/hamburger_menu.svg"}
                alt={"hamburger menu icon"}
                width={24}
                height={24}
                style={{
                  maxWidth: "100%",
                  height: "auto",
                }}
              />
            </IconButton>
          )}
        </nav>
      </div>
      <SkinuvitaDrawer drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
    </>
  )
}

export default NavbarQuickfix
